export default __webpack_public_path__ + "static/media/dcf0f20eb28c2fdbcd3120ddafc781f5.svg";